/*
 *
 * Session constants
 *
 */

export const VERIFY_SESSION = "app/session/VERIFY_SESSION";
export const VERIFY_SESSION_SUCCESS = "app/session/VERIFY_SESSION_SUCCESS";
export const VERIFY_SESSION_ERROR = "app/session/VERIFY_SESSION_ERROR";

export const LOG_IN = "app/session/LOG_IN";
export const LOG_IN_SUCCESS = "app/session/LOG_IN_SUCCESS";
export const LOG_IN_ERROR = "app/session/LOG_IN_ERROR";

export const USER_ACCOUNT = "app/session/USER_ACCOUNT";
export const USER_ACCOUNT_SUCCESS = "app/session/USER_ACCOUNT_SUCCESS";
export const USER_ACCOUNT_ERROR = "app/session/USER_ACCOUNT_ERROR";

export const LOG_OUT = "app/session/LOG_OUT";
export const LOG_OUT_SUCCESS = "app/session/LOG_OUT_SUCCESS";
export const LOG_OUT_ERROR = "app/session/LOG_OUT_ERROR";

export const FORGOT_PASSWORD = "app/session/FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "app/session/FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "app/session/FORGOT_PASSWORD_ERROR";

export const OTP_APPROVE = "app/session/OTP_APPROVE";
export const OTP_APPROVE_SUCCESS = "app/session/OTP_APPROVE_SUCCESS";
export const OTP_APPROVE_ERROR = "app/session/OTP_APPROVE_ERROR";

export const RESET_PASSWORD = "app/session/RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "app/session/RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "app/session/RESET_PASSWORD_ERROR";

export const ROUTER = "@@router/LOCATION_CHANGE";

const constants = {
  VERIFY_SESSION,
  VERIFY_SESSION_SUCCESS,
  VERIFY_SESSION_ERROR,

  LOG_IN,
  LOG_IN_SUCCESS,
  LOG_IN_ERROR,

  USER_ACCOUNT,
  USER_ACCOUNT_SUCCESS,
  USER_ACCOUNT_ERROR,

  LOG_OUT,
  LOG_OUT_SUCCESS,
  LOG_OUT_ERROR,

  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,

  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,

  OTP_APPROVE,
  OTP_APPROVE_SUCCESS,
  OTP_APPROVE_ERROR,
};

export default constants;
